// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__339a_","footer":"Form_footer__24xfw"};